import React, { useRef, useState, useCallback, useEffect } from 'react'

/**
 * ResizeHandle - Draggable divider for resizing panels
 */
function ResizeHandle({ onResize, direction = 'horizontal' }) {
  const handleRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseDown = useCallback((e) => {
    e.preventDefault()
    setIsDragging(true)
  }, [])

  useEffect(() => {
    if (!isDragging) return

    const handleMouseMove = (e) => {
      onResize(direction === 'horizontal' ? e.clientX : e.clientY)
    }

    const handleMouseUp = () => {
      setIsDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    document.body.style.cursor = direction === 'horizontal' ? 'col-resize' : 'row-resize'
    document.body.style.userSelect = 'none'

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
  }, [isDragging, onResize, direction])

  const isActive = isDragging || isHovering

  return (
    <div
      ref={handleRef}
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{
        width: direction === 'horizontal' ? 12 : '100%',
        height: direction === 'horizontal' ? '100%' : 12,
        background: 'transparent',
        cursor: direction === 'horizontal' ? 'col-resize' : 'row-resize',
        flexShrink: 0,
        position: 'relative',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* Visual indicator line */}
      <div style={{
        width: direction === 'horizontal' ? 4 : '100%',
        height: direction === 'horizontal' ? '100%' : 4,
        background: isActive ? 'var(--primary)' : 'rgba(0,0,0,0.08)',
        borderRadius: 2,
        transition: 'background 0.15s, transform 0.15s',
        transform: isActive ? 'scale(1.2)' : 'scale(1)'
      }} />
      {/* Grip dots */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: direction === 'horizontal' ? 'column' : 'row',
        gap: 3,
        opacity: isActive ? 1 : 0.4,
        transition: 'opacity 0.15s'
      }}>
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 4,
              height: 4,
              borderRadius: '50%',
              background: isActive ? 'var(--primary)' : 'rgba(0,0,0,0.3)'
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default ResizeHandle
